import React from 'react'
import StyledImage from './styled-image';
import { Link } from "gatsby"

export default function Alert({ props, curve, translations }) {
    const { icon } = props;
    const heading = translations?.heading || props?.heading
    const text = translations?.text || props?.text
    const link = translations?.link || props?.link
    return (
        <section className={`relative bg-bright-blue text-navy pt-8 ${curve ? "pb-16 -mb-12 sm:-mb-10 xl:-mb-8" : "pb-8"} ${link && !link.title ? " transition hover:bg-gradient-to-b hover:from-bright-blue-500 hover:to-bright-blue-600" : ""}`}>
            <div className="container text-center">
                {icon ?
                    <StyledImage
                        image={icon}
                        animated={true}
                        className={`w-9 h-9 mx-auto mb-1`}
                    />
                    : null}
                {heading && <h2>{heading}</h2>}
                <div className="flex flex-wrap items-center justify-center -mx-2 mt-1">
                    {text && <p className="text-lg mx-2">{text}</p>}
                    {link && (
                        <>
                            {link.url?.startsWith("/") ?
                                <Link to={link.url} target={link.target} className={`${link.title ? "btn-text link-navy-plain mx-2" : "link-stretched"}`}>
                                    {link.title}
                                </Link>
                                : <a href={link.url} target="_blank" rel="noreferrer"
                                    className={`${link.title ? "btn-text link-navy-plain mx-2" : "link-stretched"}`}>
                                    {link.title}
                                </a>}
                        </>

                    )}
                </div>
            </div>
        </section>
    )
}
